<nav>
  <div class="d-flex justify-content-between align-items-center">
    <ol class="breadcrumb justify-content-sm-start align-items-center mb-0">
      <li class="breadcrumb-item">
        <a [routerLink]="[HOME_ROUTE]">
          <app-feather-icons [icons]="'home'"></app-feather-icons>
        </a>
      </li>
      @if (breadcrumbs && breadcrumbs.parentBreadcrumb) {
        <li class="breadcrumb-item f-w-400">
          {{ breadcrumbs.parentBreadcrumb }}
        </li>
      }
      @if (breadcrumbs && breadcrumbs.childBreadcrumb) {
        <li class="breadcrumb-item f-w-400 active">
          {{ breadcrumbs.childBreadcrumb }}
        </li>
      }
    </ol>
    @if (layoutService.showBackButton()) {
      <button
        class="btn btn-secondary rounden-circle position-relative"
        (click)="goBack()"
      >
        <i class="fa fa-arrow-left"></i>
      </button>
    }
  </div>
</nav>
<hr />
